import { vec3 } from 'gl-matrix'
import gsap from 'gsap'
import Node from 'nanogl-gltf/lib/elements/Node'
import GltfTypes from 'nanogl-gltf/lib/types/GltfTypes'

import Deferred from '@/webgl/core/Deferred'
import IAnimationTrack from '@/webgl/runner/interfaces/IAnimationTrack'
import LanesRenderer from '@/webgl/runner/rendering/LanesRenderer'

export default class LanesMergeAnimation implements IAnimationTrack {
  laneSources: Node[] = []
  mask: Node
  maskScale: number = 1
  initialPositions: vec3[] = []

  constructor(private lanes: LanesRenderer) {}

  init(): void {
    this.initialPositions = []

    this.laneSources = [
      this.lanes.gltf.getElementByName(GltfTypes.NODE, 'lane_left'),
      this.lanes.gltf.getElementByName(GltfTypes.NODE, 'lane_right'),
      // this.lanes.gltf.getElementByName(GltfTypes.NODE, "lane_middle"),
    ]

    this.mask = this.lanes.gltf.getElementByName(GltfTypes.NODE, 'lane_mask')
    this.maskScale = this.mask.scale[0]

    for (const lane of this.laneSources) {
      this.initialPositions.push(vec3.clone(lane.position))
    }
  }

  update = (p: number) => {
    const invp = 1.0 - p
    for (let i = 0; i < this.laneSources.length; i++) {
      this.laneSources[i].x = this.initialPositions[i][0] * invp
    }
    this.mask.scale[0] = this.maskScale * invp
    this.mask.invalidate()
  }

  cleanup() {
    for (let i = 0; i < this.laneSources.length; i++) {
      this.laneSources[i].position.set(this.initialPositions[i])
      this.laneSources[i].invalidate()
    }
    this.mask.scale[0] = this.maskScale
    this.mask.invalidate()
  }

  play(): Promise<unknown> {
    const o = { progress: 0 }
    const defer = new Deferred<void>()
    gsap.to(o, {
      progress: 1,
      duration: 1.1,
      delay: 0.5,
      ease: 'power2.inOut',
      onUpdate: () => this.update(o.progress),
      onComplete: () => {
        defer.resolve()
      },
    })
    return defer.promise
  }
}
